import { type Surgery } from '~/storm'
import { getAssistants, getMainSurgeon, getMainSurgeonAndAssistants, sortByMainSurgeonFirst } from '~/utils/dips'

export type FormattedSurgeon = {
    shortName: string
    fullName?: string
}

export function formatSurgeonsAndAssistants(surgery: Surgery): FormattedSurgeon[] {
    const practitioners = getMainSurgeonAndAssistants(surgery.surgeryResources)
    const sortedPractitioners = practitioners.toSorted(sortByMainSurgeonFirst)

    return sortedPractitioners.flatMap(({ shortName, name }) => {
        if (!shortName) return []
        return [{ shortName: shortName.toLocaleUpperCase(), fullName: name ?? undefined }]
    })
}

export function formatSurgeonsAndAssistantsCombo(surgery: Surgery, emptyShortName = '[–]') {
    const mainSurgeon = getMainSurgeon(surgery.surgeryResources)
    const assistants = getAssistants(surgery.surgeryResources)
    const practitionerShortNames = [mainSurgeon, ...assistants].map(practitioner => practitioner?.shortName?.toLocaleUpperCase() || emptyShortName)

    if (practitionerShortNames.every(practitioner => practitioner === emptyShortName)) return 'Ikke tildelt kirurg'
    return practitionerShortNames.join(' + ')
}
